import type { ApiBaseUrlType } from '@/uTypes/api'

export const useApiBaseUrl = () => {
  const config = useRuntimeConfig()

  return (apiBaseUrlType: ApiBaseUrlType = 'v1') => {
    const env = config.public.env || 'local'
    const isProdEnv = ['stage', 'prod'].includes(env)

    const usimsaApiUrl = isProdEnv ? config.public.apiUrl : config.public.apiUrl

    const baseUrlMap = {
      v1: `${usimsaApiUrl}/esim/v1`,
      v2: `${usimsaApiUrl}/esim/v2`,
      v3: `${usimsaApiUrl}/esim/v3`
    }

    return baseUrlMap[apiBaseUrlType]
  }
}
